module.exports = __webpack_public_path__ + "img/canera.2b3f4347.jpg";